import { defineMessages } from 'react-intl'

const scope = `procurify.presenter.GetLinkedBankAccountsPresenter`

export default defineMessages({
  fetchingLinkedBankAccountsToastError: {
    id: `${scope}.fetchingLinkedBankAccountsToastError`,
    defaultMessage: 'Unable to load linked bank accounts',
  },
})
